
enum ECookies {
    TECH_AUTH_USER_COOKIE='tech_auth_user', // This cookie is for tech usage only - it changes when user is set or unset by auth provider
    AUTH_TOKEN_COOKIE='auth_token',
    CURRENT_USER_TYPE_COOKIE='current_user_type',
    CURRENT_USER_COOKIE='current_user',

    CREATE_PROJECT_DATA_COOKIE='create_project_data',
    SUGGEST_REFINED_PROJECT_DETAILS_COOKIE='suggest_refined_project_details',
    POTENTIAL_PROJECT_DETAIL_DEFINITION_WEAKNESSES_COOKIE='potential_project_detail_definition_weaknesses',
    CREATE_TASK_DATA_COOKIE='create_task_data',
}

export default ECookies;